const flowFilter = (bytes) => {
  if (bytes === 0 || bytes === "0") {
    return "0 Bytes";
  }
  if (isNaN(bytes)) {
    return "-";
  }
  const symbols = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let exp = Math.floor(Math.log(bytes) / Math.log(2));
  if (exp < 1) {
    exp = 0;
  }
  const i = Math.floor(exp / 10);
  bytes = bytes / Math.pow(2, 10 * i);

  if (bytes.toString().length > bytes.toFixed(2).toString().length) {
    bytes = bytes.toFixed(2);
  }
  return bytes + " " + symbols[i];
};

const notSearch = [".", "?", "+"];
const renderHighlight = (name, keywordArr) => {
  if (name === "" || name === undefined || name === null) {
    return name;
  }
  if (Object.keys(name).length === 0) {
    return name;
  }
  if (!keywordArr) {
    return name;
    // const str = name
    //   ? name.replaceAll("<", "&lt;").replaceAll(">", "&gt;")
    //   : name;
    // return str;
  }
  let str = name;
  // keywordArr.forEach(keyword => {
  //   const key = keyword.toLowerCase();
  //   const itemValue = name.toLowerCase();
  //   const startI = itemValue.indexOf(key);
  //   if (startI > -1 && !notSearch.includes(key)) {
  //     const replaceStr = name.substr(startI, key.length);
  //     const highlight = `<span class="red" style="color:#EC4A3A;">${replaceStr}</span>`;
  //     str = str.replaceAll(replaceStr, highlight);
  //   }
  // });

  if (keywordArr && keywordArr.length > 0) {
    const keyword = keywordArr.join("|");
    const Reg = new RegExp("(" + keyword + ")", "ig");

    if (str.search(Reg) !== -1) {
      str = str.replace(
        Reg,
        '<span style="color: #d71345;">' + "$1" + "</span>"
      );
    }
  }
  return str;
};

const flowCount = (val) => {
  return val + "次";
};
const flowCycle = (val) => {
  return val + "次/每秒";
};

const flowNum = (val) => {
  if (!val || val == "-") {
    return "0个";
  }
  return val + "个";
};

const flowMS = (val) => {
  if (!val) {
    return "-";
  }
  return val + "毫秒";
};

export { flowNum, flowMS, flowCycle, flowCount, flowFilter, renderHighlight };
